import React from 'react';
import { Colors, Text } from 'library';
import { styled } from '@mui/material';

export function FindButtons() {
    return (
        <Container>
            <StaffButton>
                <Text
                    variant="h2"
                    textStyle={{
                        color: Colors.turquoise,
                        cursor: 'pointer',
                    }}
                    bold
                >
                    Find Staff
                </Text>
                <Line />
            </StaffButton>
        </Container>
    );
}

const Container = styled('div')({
    display: 'flex',
});

const StaffButton = styled('div')({
    marginRight: 25,
});

const Line = styled('div')({
    backgroundColor: Colors.turquoise,
    height: 4,
});
